import React from 'react';
import PropTypes from 'prop-types';
import { Parser } from 'html-to-react';
import Reactions from '../../../../../components/reactions';
import BlogPostService from '../../../../../services/blogPost.service';
import Comments from '../../../../../components/comments';
import RightSide from '../../rightSide';
import sh from '../../../../../helpers/string.helper';

const htmlToComponents = new Parser().parse;


const BlogPost = ({
  t,
  img,
  time,
  item,
  posts,
  isLoad,
  hasMore,
  checked,
  commented,
  chooseCat,
  categories,
  updateChecked,
  backgroundColor,
  loadMoreCategories,
}) => (
  <React.Fragment>
    <svg aria-hidden="true" focusable="false" className="svg-hidden">
      <linearGradient id="gradientfill" className={`emoj-list ${backgroundColor}`}>
        <stop offset="0%" stopColor="var(--color-stop-1)" />
        <stop offset="100%" stopColor="var(--color-stop-2)" />
      </linearGradient>
    </svg>
    <RightSide
      color={backgroundColor}
      isLoad={isLoad}
      active={item.id}
      hasMore={hasMore}
      checked={checked}
      lastPosts={posts}
      chooseCat={chooseCat}
      categories={categories}
      updateChecked={updateChecked}
      loadMoreCategories={loadMoreCategories}
    />
    <div className="middlew">
      <div className="middleinner boxs">
        <div className="Blog2t_outer">
          <div className="blog2step blog2step1">
            <div className="Blogs2">
              <div className="BlogsBoxouter">
                <div className="BlogsBox">
                  { img && (<img src={img} alt="blog" className="img-responsive width1" />)}
                  <div className="bottom imrtant-style">
                    <h6>{item.creator}<span className="read-time">{`${time} ${t('Min read')}`}</span></h6>
                    <h5 className="post-title">{item.title}</h5>
                    {item.content && htmlToComponents(sh.replaceSpecialChars(item.content))}
                  </div>
                </div>
              </div>
            </div>
            <Reactions
              cssClass={`emoj-list ${backgroundColor}`}
              model_id={item.id}
              model_name={BlogPostService.modelName}
            />
            {commented && <Comments
              model_id={item.id}
              commented={commented}
              model_name={BlogPostService.modelName}
              backgroundColor={backgroundColor}
            />}
          </div>
        </div>
      </div>
    </div>
  </React.Fragment>
);

BlogPost.propTypes = {
  t: PropTypes.func.isRequired,
};

export default BlogPost;



// WEBPACK FOOTER //
// ./src/views/modules/blog/blogPost/ext/BlogPost.jsx